import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { propertiesApi, investorApi } from '../services/adminApi';
import '../styles/AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { adminUser, isSuperAdmin } = useAdminAuth();
  const [counts, setCounts] = useState({
    properties: '-',
    investors: '-'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [propertiesRes, investorsRes] = await Promise.allSettled([
          propertiesApi.getAll({ start: 0, pageSize: 500 }),
          investorApi.getAll({ page: 1, pageSize: 1 })
        ]);

        const getPropertyCount = (res) => {
          if (res.status === 'fulfilled') {
            const data = res.value;
            if (data?.totalCount !== undefined) return data.totalCount;
            if (data?.TotalCount !== undefined) return data.TotalCount;
            let items = data?.data?.[0] || data?.Data?.[0] || data?.data || data?.Data || [];
            if (Array.isArray(items)) return items.length;
          }
          return '-';
        };

        const getInvestorCount = (res) => {
          if (res.status === 'fulfilled') {
            const data = res.value;
            const wrapper = data?.data?.[0] || data?.data || data || {};
            if (wrapper?.total !== undefined) return wrapper.total;
            if (data?.total !== undefined) return data.total;
            let items = wrapper?.data || [];
            if (Array.isArray(items)) return items.length;
          }
          return '-';
        };

        setCounts({
          properties: getPropertyCount(propertiesRes),
          investors: getInvestorCount(investorsRes)
        });
      } catch (err) {
        console.error('Error fetching dashboard counts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  const stats = [
    { title: 'Properties', count: loading ? '...' : counts.properties, icon: '🏠', color: '#00c896', link: '/admin/properties' },
    { title: 'Investors', count: loading ? '...' : counts.investors, icon: '👤', color: '#3b82f6', link: '/admin/investor' },
  ];

  return (
    <div className="admin-dashboard">
      <div className="admin-page-header">
        <h1>Dashboard</h1>
        <p>Welcome back, {adminUser?.name}!</p>
      </div>

      <div className="admin-stats-grid">
        {stats.map((stat, index) => (
          <div 
            key={index} 
            className="admin-stat-card clickable" 
            style={{ borderColor: stat.color, cursor: 'pointer' }}
            onClick={() => navigate(stat.link)}
          >
            <div className="admin-stat-icon" style={{ backgroundColor: `${stat.color}20` }}>
              {stat.icon}
            </div>
            <div className="admin-stat-info">
              <h3>{stat.count}</h3>
              <p>{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="admin-dashboard-content">
        <div className="admin-info-card">
          <h2>Quick Actions</h2>
          <div className="admin-quick-actions">
            <a href="/admin/properties" className="admin-action-btn">
              <span>🏠</span> Manage Properties
            </a>
            <a href="/admin/investor" className="admin-action-btn">
              <span>👤</span> View Investors
            </a>
            {isSuperAdmin() && (
              <a href="/admin/users" className="admin-action-btn">
                <span>👥</span> Manage Admins
              </a>
            )}
          </div>
        </div>

        <div className="admin-info-card">
          <h2>System Information</h2>
          <div className="admin-system-info">
            <div className="admin-info-row">
              <span>Role:</span>
              <span>{isSuperAdmin() ? 'Super Admin' : 'Admin'}</span>
            </div>
            <div className="admin-info-row">
              <span>Email:</span>
              <span>{adminUser?.email}</span>
            </div>
            <div className="admin-info-row">
              <span>API:</span>
              <span>{process.env.REACT_APP_API_URL || 'Not configured'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
